package dev.moetz.sslcertificatetool.page

import dev.moetz.materialize.mCol
import dev.moetz.materialize.mContainer
import dev.moetz.materialize.mHeader
import dev.moetz.materialize.mRow
import dev.moetz.sslcertificatetool.design.mFooter
import react.FC
import react.Props
import react.dom.html.ReactHTML.h5

external interface NotFoundPageServiceProps : Props {
}

val NotFoundPageService = FC<NotFoundPageServiceProps> { props ->
    mHeader(title = "SSL Certificate Tool")

    mContainer {
        mRow {
            mCol(small = 12, additionalClass = "center-align") {
                h5 { +"Not found" }
            }
        }
    }

    mFooter()
}